import { downloadExcelReport, GetYearsFromApi } from 'helpers/downloadExcelReport'
import React, { Children, useCallback, useEffect, useMemo, useState } from 'react'
import { Button } from "reactstrap"
import Cargando from '../Cargando'
import "./stylesExcelButton.scss"
export type PropsButtonDownloadReportTable = {
    api: string,
    apiYears: string,
    handleStatus?: (status: number) => void,
    nombreBoton?: string,
    onChangeYear?: (anio: number) => Promise<void>,
    onChangeYearNotAsync?:(anio:number) => void,
    yearElegido?: number
}

export const classUsandoBoton = "btnEspolAceptar";

const ComponentButtonExcel = (props: PropsButtonDownloadReportTable) => {

    const [loadingRequest, setloadingRequest] = useState<boolean>(false)
    const [optionsSelect, setoptionsSelect] = useState<number[]>([])
    const [valueSeleccionado, setvalueSeleccionado] = useState<number>(0)

    //const classUsandoBoton = "btnEspolAceptar";
    const classUsandoContainerBoton = 'containerButtonExcel'


    async function GetYearsFromSolicitudes() {
        var resultado: number[] = await GetYearsFromApi(props.apiYears);
        setoptionsSelect(resultado);
    }

    async function HandleClickButton(endpoint: string, numberYear: number) {
        setloadingRequest(true);
        var status_action: number = await downloadExcelReport(endpoint, props.nombreBoton, numberYear);
        setloadingRequest(false);
    }

    // const onChangeYear = useCallback(
    //    (anio) => async () => {
    //         if(typeof(props.onChangeYear) === "function") {
    //            await props.onChangeYear()
    //         }
    //         setvalueSeleccionado(anio);
    //    },
    //   [valueSeleccionado,props.onChangeYear],
    // )

    async function onChangeYear(anio: number) {
        if (typeof (props.onChangeYear) === "function") {
            await props.onChangeYear(anio)
        }
        if (typeof (props.onChangeYearNotAsync) === "function") {
            await props.onChangeYearNotAsync(anio)
        }
        setvalueSeleccionado(anio);
    }


    useEffect(() => {
        GetYearsFromSolicitudes();
    }, [])

    useEffect(() => {
        // if(props.yearElegido && props.yearElegido === 0){
        //     setvalueSeleccionado(0)
        // }
        // else if ( props.yearElegido && props.yearElegido > 0){
        //     setvalueSeleccionado(props.yearElegido)
        // }
        // else 
        if (props.yearElegido) {
            setvalueSeleccionado(props.yearElegido)
        }
        else if (optionsSelect.length > 0 && props.yearElegido !== 0) {
            setvalueSeleccionado(optionsSelect[0])
        }
    }, [optionsSelect, props.yearElegido])






    const ContainerButton: React.FC = (props) => {
        return (
            <div className={classUsandoContainerBoton}>
                <select onChange={(e) => onChangeYear(+e.target.value)} value={valueSeleccionado}>
                    <option key={"opcionesYearReportTodos"} value={0} label={"Todos"}/>

                    {optionsSelect.map((valores, indi) => {
                        return (
                            <option key={"opcionesYearReport" + indi} value={valores} label={valores.toString()} />
                        )
                    })
                    }
                </select>

                {props.children}
            </div>
        )
    }

    const ButtonLoading = () => {
        return (
            <ContainerButton >
                <Button
                    className={classUsandoBoton}
                >
                    Descargando Reporte... <Cargando />
                </Button>
            </ContainerButton>

        )
    }

    const ButtonExcel = (numberYear: number) => {
        return (
            <ContainerButton>
                <Button
                    className={classUsandoBoton}
                    onClick={() => HandleClickButton(props.api, numberYear)}
                >
                    Descargar Reporte
                </Button>
            </ContainerButton>
        )
    }


    return (
        <React.Fragment>
            <div>
                {
                    loadingRequest && optionsSelect.length > 0 && ButtonLoading()
                }
                {
                    !loadingRequest && optionsSelect.length > 0 && valueSeleccionado > -1 && ButtonExcel(valueSeleccionado)
                }
            </div>

        </React.Fragment>

    )



}

const ButtonDownloadReportTable = React.memo(ComponentButtonExcel)

export default ButtonDownloadReportTable    